import { _Linkable, Meta } from 'types/generated/graphql';
import { PrismicResponsiveImage, PrismicRichtextObject } from 'prismic/types';
import { Maybe } from 'graphql/jsutils/Maybe';

interface Location extends _Linkable {
  house_nr?: number | null;
  name?: string | null;
}

export interface Termin {
  date: string | null;
  timeslot: string | null;
  location: Location | null;
}

export interface TagesplanItem {
  _linkType: Maybe<string> | undefined;
  _meta: Meta;
  display_name: string | null;
  category: string | null;
  image: PrismicResponsiveImage;
  description: PrismicRichtextObject[];
  termin: Termin | null;
  _dateToSort?: Date;
  _type: string;
}

export interface TagesplanResponse {
  items: TagesplanItem[];
  date: string;
}

export const EventCategoriesObj = {
  Handwerk: '0',
  // Gastronomie: '1', Temporarily deactivated from API Calls, will later be enabled again https://jira.nexum.de/browse/BDRDIGIREL-205
  Mitmachaktivitaet: '2',
  Veranstaltung: '3',
};

export enum EventSortBy {
  hour_start,
}
